import { ascending } from 'd3'

export function makeRows (browserAppAccount, entitiesSyncStatsResponse) {
  if (!browserAppAccount.data.entities) return []
  if (!Array.isArray(browserAppAccount.data.entities)) return []
  if (browserAppAccount.data.entities.length === 0) return []

  const entities = Array.from(browserAppAccount.data.entities)

  entities.sort(function (a, b) {
    return ascending(a.name, b.name)
  })

  entities.forEach(entity => {
    entity.syncStats = {
      //
      latestDone: entitiesSyncStatsResponse?.latestDone?.find(syncStats => syncStats.accounting_organisation_id === entity.id),
      //
      ongoing: entitiesSyncStatsResponse?.ongoing?.find(syncStats => syncStats.accounting_organisation_id === entity.id),
      //
      nextScheduled: entitiesSyncStatsResponse?.nextScheduled?.find(syncStats => syncStats.accounting_organisation_id === entity.id)
    }
  })

  return entities
}
